<script>
import ModelShow from '../models/show';

export default {
  extends: ModelShow,
  page: {
    title: "Detail Delivery Orders",
  },
  props: {
    cardTitle: { default() { return this.lodash.startCase(this.$t('harvests.singular')) } },
    resourceRoute: { default: 'harvests' },
    modelVariable: { default: 'harvest' },
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('harvests.plural')),
    }
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.upperFirst(this.$t('harvests.plural')),
          href: "/harvests",
        },
        {
          text: this.model && this.model.id ? this.model.id : this.$route.params.key,
          href: `/harvests/${this.$route.params.key}`,
          active: true,
        },
      ]
    },
    modelMapped() {
      return this.lodash.isEmpty(this.model) ? [] : [{
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.jala_harvest`)),
        value: this.model.jala_harvest_id
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.harvested_at`)),
        value: this.$moment.utc(this.model.ordered_at).local().format('DD MMMM YYYY')
        // }, {
        //   key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.due_at`)),
        //   value: this.$moment.utc(this.model.due_at).local().format('DD MMMM YYYY')
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.weight`)),
        value: this.model.weight
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.size`)),
        value: this.model.size
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.label`)),
        value: this.model.label
        // }, {
        //   key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.total`)),
        //   value: this.$numeral(this.model.total).format('0,0.00')
      }, {
        key: this.lodash.upperFirst(this.$t(`models.description`)),
        item: this.model.note,
        value: {
          props: { item: { type: String, default: '' } },
          template: `<span v-html="item || '-'"></span>`
        }
      }]
    }
  },
  methods: {
    getModelName() {
      return this.model['order_id'];
    },
    delete() {
      return this.$axios.delete(`/harvests/${this.$route.params.key}`)
    },
    fetchModel() {
      this.loading = true;
      return this.$axios.get(`/harvests/${this.$route.params.key}`, {
        params: {
          with: 'customer,trip.vehicle'
        }
      }).then((response) => {
        const { data: { data } } = response;
        this.model = data;
        return response;
      }).catch((error) => this.failedAlert(error))
        .finally(() => this.loading = false)
    }
  }
}
</script>
